import { render, staticRenderFns } from "./editVersion.vue?vue&type=template&id=2a5c8956&scoped=true"
import script from "./editVersion.vue?vue&type=script&lang=js"
export * from "./editVersion.vue?vue&type=script&lang=js"
import style0 from "./editVersion.vue?vue&type=style&index=0&id=2a5c8956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c8956",
  null
  
)

export default component.exports